import React, { Component, Fragment } from "react";
import { Row } from "reactstrap";
 
import IntlMessages from "../../../helpers/IntlMessages";
// import IntlMessages from "../../../helpers/IntlMessages";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
// import FavoritePlacesView from "../../../containers/favorite-places/places";

class FavoritePlacesLayout extends Component {
  render() {
    // const { messages } = this.props.intl;
    // const messages = [];
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb
              heading="menu.favorite-places"
              match={this.props.match}
            />
            <Separator className="mb-5" />
          </Colxx>
        </Row>
          <h2> <IntlMessages id="fav.comming-soon" /> </h2>    
      </Fragment>
    );
  }
}

export default  FavoritePlacesLayout ;
